// import * as ExcelJS from "exceljs";
import * as ExcelJS from "exceljs/dist/exceljs";
import { saveAs } from "file-saver";

const generateExcelJSWorksheet = (cols, data) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Sheet1");
  worksheet.addRow(cols.map((col) => col.title));
  worksheet.getRow(0).font = { bold: true };

  data.forEach((element) => {
    const dataArray = [];
    cols.forEach((el) => {
      dataArray.push(element[el.dataIndex] ? element[el.dataIndex] : "");
    });
    worksheet.addRow(dataArray);
  });
  return workbook;
};

const ExportExcel = async (cols, data, fileName) => {
  const workbook = generateExcelJSWorksheet(cols, data);
  const buffer = await workbook.xlsx.writeBuffer();
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const fileExtension = ".xlsx";
  const blob = new Blob([buffer], { type: fileType });
  saveAs(blob, `${fileName}${fileExtension}`);
};

export default ExportExcel;
